
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#2F80ED","d":"M58.41 17.76h-3.1a6.47 6.47 0 00-6.47 6.47v34.8c0 3.56 2.9 6.46 6.47 6.46h3.1c3.57 0 6.47-2.9 6.47-6.47V24.23c0-3.57-2.9-6.47-6.47-6.47z"}}),_c('path',{attrs:{"fill":"#2D9CDB","d":"M36.99 26.98h-3.1a6.47 6.47 0 00-6.47 6.47v25.57c0 3.57 2.9 6.47 6.47 6.47h3.1c3.57 0 6.47-2.9 6.47-6.47V33.45c0-3.58-2.9-6.47-6.47-6.47z"}}),_c('path',{attrs:{"fill":"#56CCF2","d":"M15.57 37.44h-3.1A6.47 6.47 0 006 43.91v15.11c0 3.57 2.9 6.47 6.47 6.47h3.1c3.57 0 6.47-2.9 6.47-6.47V43.91c0-3.57-2.9-6.47-6.47-6.47z"}}),_c('path',{attrs:{"fill":"#2F80ED","d":"M45.24 22.46l9.8-7.35c.88-.66 2.09-.68 3-.04l10.4 7.35a2.55 2.55 0 01-1.47 4.63h-20.2a2.55 2.55 0 01-1.53-4.59z"}})])
          )
        }
      }
    